import getCurrentSpaceValue from "./get-current-space-value";

/**
 * Get computed, comma-separated properties in the current level (translateX,...)
 * @param {ValueLevelMapProps} map
 * @param {Map<String, any>} activeProperties
 * @param {Boolean} isInitial
 * @param {Boolean} isSafariInitial
 * @returns {String}
 */
const getCurrentCommaFn = (
  map,
  activeProperties,
  isInitial,
  isSafariInitial
) => {
  const result = [];
  const values = /** @type {ArrayOfStoreItemProps} */ (map.get("values"));
  const divider = /** @type {String} */ (map.get("divider"));
  const fnWrapper = map.get("fn");

  for (const original of values) {
    /**
     * {"type" => "space"}
     */
    const value = /** @type {ValueLevelMapProps} */ (
      /** @type {unknown} */ (original)
    );

    result.push(
      getCurrentSpaceValue(value, activeProperties, isInitial, isSafariInitial)
    );
  }

  return `${fnWrapper}(${result.join(divider)})`;
};

export default getCurrentCommaFn;
